export default __webpack_public_path__ + "static/media/TraspasoSucursal.838fc1a6.svg";